import type { ChannelType } from '@/types';

export const OMNICHANNEL_STATUS_QUERY_KEY = 'omnichannelStatus';
export const OMNICHANNEL_ACCOUNTS_QUERY_KEY = 'omnichannelAccounts';
export const OMNICHANNEL_CONVERSATIONS_QUERY_KEY = 'omnichannelConversations';
export const OMNICHANNEL_MESSAGES_QUERY_KEY = 'omnichannelMessages';

export const omnichannelKeys = {
  status: () => [OMNICHANNEL_STATUS_QUERY_KEY] as const,
  accounts: (channel: ChannelType) =>
    [OMNICHANNEL_ACCOUNTS_QUERY_KEY, channel] as const,
  conversations: (channel: ChannelType, pageId?: string, page?: number) =>
    [OMNICHANNEL_CONVERSATIONS_QUERY_KEY, channel, pageId, page] as const,
  messages: (conversationId: string, channel: ChannelType, pageId?: string) =>
    [OMNICHANNEL_MESSAGES_QUERY_KEY, conversationId, channel, pageId] as const,
};
